export class sksisUrls {
  // baseUrl = 'https://restapi2.sksis.ca/api/v2/';
  baseUrl = 'https://gateway.sksis.ca/api/v2/';

  baseTableUrl = this.baseUrl + 'sksis/_table/';

  // DefaultXDreamFactoryAPIKey = '12e38ce3f01499221dff9abff2ddd35a7b6d18234994ed65cc16ccaf031b158c';
  DefaultXDreamFactoryAPIKey = '5d3ca000de44d65a890bd346ad7b169fd5f7bbb25d1764219d8fa841a92f35e9';
  DreamFactoryURL = this.baseUrl + 'user/session';

  // Dreamfactory services
  dfSessionUrl = this.baseUrl + 'user/session';
  dfUserUrl = this.baseUrl + 'system/user';
  dfServicesUrl = this.baseUrl + 'system/service';
  dfRolesUrl = this.baseUrl + 'system/role';
  dfGetRolesForUserUrl =
    this.baseUrl + 'system/user?related=user_to_app_to_role_by_user_id&filter=id%20%3D%20';

  uploadPointDataUrl = this.baseUrl + 'sksis/_func/create_point_data';
  updatePointDataUrl = this.baseUrl + 'sksis/_func/update_point_data;';
  getImageUrl = this.baseUrl + 'files/sk_soil_photos/';
  getPublicationsUrl = this.baseUrl + 'files/sk_soil_publications/';
  deletePitPointUrl = this.baseUrl + 'sksis/_func/delete_pit_point_data';
  getLatLongFromGeomUrl = this.baseUrl + 'sksis/_proc/get_lat_lng_from_geom?point_id=';
  updatePitUrl = this.baseUrl + 'sksis/_func/update_soil_pit_data';
  updateHorizonsUrl = this.baseUrl + 'sksis/_func/update_soil_pits_horizons_data';
  addHorizonUrl = this.baseUrl + 'sksis/_func/add_pit_horizons';
  centerSectionUrl = this.baseUrl + 'sksis/_proc/get_center_section';
  checkCoordUrl = this.baseUrl + 'sksis/_proc/check_coordinate';
  getCoordByRmUrl = this.baseUrl + 'sksis/_proc/get_latlng_rm';
  getCoordByPolyIdUrl = this.baseUrl + 'sksis/_proc/get_latlng_poly_id';
  getEcoRegionInfoUrl = this.baseUrl + 'sksis/_proc/get_ecoregions_range_mod';
  getSurficialGeologyInfoUrl = this.baseUrl + 'sksis/_proc/get_surficial_geology';

  // Table references
  pointDataUrl = this.baseTableUrl + 'sk_point_data';
  soilPitUrl = this.baseTableUrl + 'soil_pits';
  soilPitHorizonUrl = this.baseTableUrl + 'soil_pits_horizons?filter=soil_pits_id=';
  deletePitUrl = this.baseTableUrl + 'soil_pits_horizons/';
  polygonComponentsUrl = this.baseTableUrl + 'polygon_components';
  salsymToClassUrl = this.baseTableUrl + 'salsym';
  capClassUrl = this.baseTableUrl + 'capclass';
  labelToAssocUrl = this.baseTableUrl + 'pm';
  phToDefinitionUrl = this.baseTableUrl + 'ph_symbol_definitions';
  mapUnitToDescUrl = this.baseTableUrl + 'soiland';
  rmsUrl = this.baseTableUrl + 'saskadmin_2016_rural_municipality';
  errateUrl = this.baseTableUrl + 'errata_sksis';
  irrigUrl = this.baseTableUrl + 'irrigation_class_rating';
  ecositeURL = this.baseTableUrl + 'ecosite2016_range';

  // Geoserver
  geoserverBaseURL = 'https://geosis.sksis.ca/geoserver/dss/wms';
}
